import type { ThemeTokens } from '../theme_tokens_types'

const radius = {
  none: 0,
  sm: 4,
  md: 8,
  lg: 12,
  xl: 18
}

export const defaultConfig: ThemeTokens = {
  successColor: '#3EC46D',
  errorColor: '#EF6256',
  starColor: '#FFD36B',
  panelHi: '#4F82A8',
  panel: '#163A59',
  primaryHi: '#6F9EC2',
  faintColor: '#FFFFFF66',

  fontFamily: 'Roboto',
  fontFamilyMono: 'monospace',
  secondaryFontFamily: 'Raleway',
  contentFontFamily: 'Source Sans 3',
  rootBg: '#0f335d',
  layerUpperBg: '#06375250',
  layerUpperBlur: '6px',
  layerUpperOpacity: '1',
  homeBgOverlay: '',
  homeProceedBtnColor: '#32c5ff50',
  primaryBg: '#458FB2',
  secondaryBg: '#1b456f',
  tritonBg: '#2D465C',
  primaryColor: '#ffffff',
  secondaryColor: '#ffffff',
  accentColor: '#ffffff',
  infoChannelWidgetBg: '#ffffff07',
  mapMainColor: '#FFFFFF40',
  btnActiveColor: '#C8C8C86B', // 'rgb(200 200 200 / 42%)',
  boxShadow: 'none',
  btnMainColor: '#FFFFFF40',
  btnBgColor: '#22719150',
  btnTextColor: '#ffffff',
  btnActiveBgColor: '#458FB2',
  btnLockerBg: '#FFFFFF40',
  meterColor: '#458fb1',
  meterFontColor: '#eff0f4',
  meterHeadingArcRgbColor: '[49,109,136]',
  meterDepthGradientColors: '["#4FC3FB", "#175a8c", "#0f3c6d"]',
  menuBg: '#FFFFFF40',
  menuColor: '#ffffff70',
  menuActiveColor: '#ffffff',
  menuColorFilter: 'opacity(0.5)',
  menuActiveColorFilter: 'brightness(100%)',
  chartPrimaryColor: '#3C95C6',
  chartSecondaryColor: '#ffffff',
  chartBarLinearGradient0Color: '#4FC3FB',
  chartBarLinearGradient0Opacity: '1',
  chartBarLinearGradient1Color: '#175a8c',
  chartBarLinearGradient1Opacity: '0',
  chartAirColor: '#2694CA',
  chartWaterColor: 'yellow',
  chartLineColor: '#2AA7DE',
  chartTickColor: '#0f335d',
  gaugeWind1Color: '#373450',
  gaugeWind2Color: '#286068',
  menuTabColor: '#244E78B3', // 'rgba(36, 78, 120, 0.7)',
  submenuTabColor: '#22719150',
  scrollbarThumbColor: '#3A567DE8',
  scrollbarTrackColor: '#3A567D1C',
  calendarEventHeaderColor: '#46B2DB',
  calendarPrimaryColor: '#dadada',
  calendarSecondaryColor: '#458fb1',
  calendarSelectedRangeColor: '#ffffff10 0 0 no-repeat padding-box',
  calendarOnTimesPagePrimaryColor: '#dadada',
  headingGaugeRadialGradient0Color: '',
  headingGaugeRadialGradient1Color: '',
  seaTempColor: '#749DBF',
  mechanicalComponentCircleColor: '',
  mechanicalComponentCircleGradient0Color: '#3d597d',
  mechanicalComponentCircleGradient1Color: '#29476e',
  logoDark: 'brightness(100%)',
  logoLight: 'brightness(100%)',
  tableBorderColor: '#ffffff',
  satAntennasRect: '#3d597d',
  mechanicalComponentPrimaryColor: '#2ebef8',
  mechanicalComponentSecondaryColor: '#c1c1c1',
  mechanicalProgressBar: '#1b456f',
  svgWireCircleColor: '#cbc5c5',
  drawFabButtonColor: '#0D2645BC',
  mapNavBtnBgc: '',

  btnRadius: radius.sm,
  canvasWidgetRadius: radius.xl,
}
